import { AutoPaymentOptions } from '@melio/platform-api-axios-client';
import { convertCentsToDollars } from '@melio/platform-utils';

export const convertAutoPaymentOptionsResponseCentsToDollars = (autoPaymentOptions: AutoPaymentOptions) =>
  convertCentsToDollars(autoPaymentOptions, [
    'autoPaymentFundingSources[].maxFixedAmount',
    'autoPaymentFundingSources[].minFixedAmount',
  ]);
